/**
 * Payment method fee calculations shared across appointment UI and reports.
 */

export function roundMoney(value) {
  return Math.round((Number(value) || 0) * 100) / 100;
}

/**
 * Resolve fee percent for an appointment (snapshot first, then lazy default).
 * @param {{ paymentMethodId?: string, paymentMethodFeePercent?: number|string }} appointment
 * @param {number} defaultFeePercent
 */
export function resolveFeePercent(appointment, defaultFeePercent = 0) {
  if (
    appointment &&
    appointment.paymentMethodFeePercent != null &&
    appointment.paymentMethodFeePercent !== ''
  ) {
    const pct = Number(appointment.paymentMethodFeePercent);
    if (Number.isFinite(pct)) {
      return Math.max(0, Math.min(100, pct));
    }
  }
  if (!appointment?.paymentMethodId) {
    return Math.max(0, Math.min(100, Number(defaultFeePercent) || 0));
  }
  return Math.max(0, Math.min(100, Number(defaultFeePercent) || 0));
}

/**
 * @param {number} grossPaid
 * @param {number} feePercent
 */
export function getFeeAmount(grossPaid, feePercent) {
  const gross = Number(grossPaid) || 0;
  if (gross <= 0) return 0;
  return roundMoney(gross * (Number(feePercent) || 0) / 100);
}

/**
 * @param {number} grossPaid
 * @param {number} feePercent
 */
export function getNetPaidAmount(grossPaid, feePercent) {
  return roundMoney((Number(grossPaid) || 0) - getFeeAmount(grossPaid, feePercent));
}

/**
 * Format fee percent for display (up to 2 decimal places).
 * @param {number} feePercent
 */
export function formatFeePercent(feePercent) {
  const n = Number(feePercent);
  if (!Number.isFinite(n)) return '0';
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

/**
 * Validate fee percent input (0–100, max 2 decimal places).
 * @param {*} value
 */
export function isValidFeePercent(value) {
  if (value === '' || value == null) return false;
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0 || n > 100) return false;
  const str = String(value).replace(',', '.');
  const parts = str.split('.');
  if (parts.length === 2 && parts[1].length > 2) return false;
  return true;
}
